import { ModalNew as Modal } from "components/Modal/ModalNew";
import { useQueryClient } from "@tanstack/react-query";
import { AddDocument } from "components/DocumentForm/AddDocument";

interface AllowedCategory {
	category_id: string;
	subcategory_id?: string;
}

interface AddNewDocumentModalProps {
	allowedCategories: AllowedCategory[];
	allowedCategoryIds: number[];
	categories: { label: string; value: number }[];
	isOpen: boolean;
	onClose: () => void;
	onCreated: (id: number) => void;
}

export const AddNewDocumentModal: React.FC<AddNewDocumentModalProps> = ({
	isOpen,
	onClose,
	onCreated,
	allowedCategoryIds,
	allowedCategories,
}) => {
	const queryClient = useQueryClient();

	const lockCategory = allowedCategoryIds.length === 1;
	const lockedSubcategoryId =
		lockCategory && allowedCategories.length === 1 && allowedCategories[0].subcategory_id
			? Number(allowedCategories[0].subcategory_id)
			: null;
	const lockSubcategory = lockedSubcategoryId !== null;

	const handleSuccessfulSubmit = () => {
		queryClient.invalidateQueries({ queryKey: ["corporateDocument"] });
		onClose();
	};

	const handleCreated = (id: number) => {
		onCreated(id);
	};

	if (!isOpen) {
		return null;
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			headerContent="Add New Document"
		>
			<AddDocument
				onSuccessfulSubmit={handleSuccessfulSubmit}
				onCreated={handleCreated}
				lockCategory={lockCategory}
				lockSubcategory={lockSubcategory}
				lockedSubcategoryId={lockedSubcategoryId}
				initialCategoryId={lockCategory ? allowedCategoryIds[0] : undefined}
			/>
		</Modal>
	);
};
